import { render, staticRenderFns } from "./LogoBling.vue?vue&type=template&id=571b6e22&scoped=true&"
import script from "./LogoBling.vue?vue&type=script&lang=js&"
export * from "./LogoBling.vue?vue&type=script&lang=js&"
import style0 from "./LogoBling.vue?vue&type=style&index=0&id=571b6e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b6e22",
  null
  
)

export default component.exports